import React from 'react';
import './LakeviewLoader.css';

const text = '/assets/img/text_lake.png';

const LakeviewLoader = ({ loader }) => {
  if (!loader) return null;

  return (
    <div className="lakeview-loader-overlay">
      <div className="lakeview-boat-wrapper rounded bg-white">
        <div className="lakeview-boat">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 729 461"
            preserveAspectRatio="xMidYMid meet"
          >
            <g
              transform="translate(0,461) scale(0.1,-0.1)"
              fill="#000000"
              stroke="none"
            >
              <path d="M3800 4471 c-5 -11 -10 -35 -10 -53 -1 -18 -8 -51 -16 -73 -8 -22
-18 -71 -23 -109 -10 -69 -46 -148 -311 -666 -53 -105 -98 -205 -115 -260 -10
-30 -26 -72 -36 -93 -28 -58 -25 -78 7 -42 48 55 116 167 185 309 38 78 90
177 114 221 25 44 50 91 56 105 46 104 110 220 120 220 5 0 9 -24 9 -54 0 -30
5 -67 12 -83 8 -20 12 -127 13 -358 0 -196 6 -381 13 -455 14 -128 14 -123
-19 -466 -7 -64 -9 -142 -6 -173 6 -50 14 -77 46 -156 29 -70 41 -162 31 -245
-5 -47 -16 -143 -24 -214 -9 -81 -13 -166 -9 -227 4 -72 3 -102 -7 -114 -10
-13 -46 -15 -222 -15 -211 0 -293 7 -425 37 -64 15 -84 15 -190 3 -65 -8 -228
-17 -363 -20 -196 -5 -268 -11 -360 -29 -131 -26 -214 -24 -344 9 -43 11 -100
20 -127 20 -27 0 -49 3 -49 8 0 4 31 27 69 51 82 51 122 89 260 241 57 63 147
160 200 215 53 55 117 125 141 155 54 67 98 111 171 173 31 26 76 75 100 109
60 84 99 122 183 176 76 49 95 66 159 152 23 30 44 57 48 60 20 18 79 130 79
150 -1 24 -1 24 -12 5 -7 -11 -16 -25 -22 -31 -6 -6 -36 -42 -66 -80 -80 -101
-180 -198 -225 -220 -22 -10 -71 -51 -110 -92 -38 -40 -99 -101 -134 -135
-348 -340 -535 -545 -577 -632 -22 -46 -90 -115 -179 -181 -44 -32 -89 -67
-100 -77 -30 -27 -60 -31 -112 -13 -66 23 -94 20 -133 -13 -33 -28 -35 -32
-34 -92 1 -61 29 -171 60 -229 21 -41 94 -199 94 -205 0 -5 50 -116 88 -195
31 -65 131 -173 207 -225 46 -32 53 -41 43 -53 -10 -12 -29 -13 -96 -8 -83 6
-144 28 -171 60 -7 8 -52 34 -99 56 -103 49 -101 48 -177 90 -82 46 -84 46
-138 59 -67 16 -92 14 -140 -10 -23 -11 -78 -34 -121 -50 -86 -32 -112 -48
-200 -133 -64 -62 -69 -85 -9 -42 21 15 58 41 83 59 25 18 72 40 105 51 33 10
81 27 107 37 44 18 50 18 108 3 66 -17 295 -127 406 -195 136 -84 303 -92 439
-21 48 24 175 112 203 139 22 21 60 38 157 71 136 46 193 56 281 48 138 -11
163 -17 251 -62 47 -24 116 -51 152 -60 71 -16 128 -48 177 -100 40 -41 112
-76 204 -99 63 -15 80 -16 129 -5 135 30 264 86 372 161 88 62 156 82 279 83
l105 1 88 -59 c80 -54 120 -90 156 -143 8 -12 41 -34 75 -49 58 -28 66 -29
191 -27 122 3 135 5 219 38 49 19 95 35 102 35 6 0 25 7 40 15 16 8 38 15 50
15 11 0 47 9 80 20 82 27 209 27 244 0 14 -11 30 -20 36 -20 6 0 36 -11 67
-24 119 -53 209 -69 407 -73 198 -5 244 1 370 44 84 28 110 47 110 76 0 17 -5
19 -39 14 -22 -3 -55 -12 -73 -22 -114 -57 -426 -60 -553 -6 -11 4 -38 14 -60
21 -22 7 -51 19 -63 27 l-24 15 89 91 c99 102 115 123 167 219 81 151 115 272
140 498 8 69 15 131 17 139 7 25 -69 29 -711 35 -513 4 -639 3 -760 -10 -145
-15 -415 -35 -500 -37 -25 0 -99 3 -165 8 l-121 8 0 36 c0 20 -4 88 -8 152
l-9 117 89 11 c49 6 109 14 134 17 25 3 70 12 100 19 30 7 80 19 110 25 30 7
78 19 105 27 28 8 68 19 90 25 60 16 142 46 204 75 77 35 178 65 316 92 147
30 328 107 429 184 49 38 102 65 167 86 41 13 157 124 165 158 6 23 -5 44 -78
140 -25 34 -63 93 -84 130 -21 37 -60 93 -88 124 -31 33 -73 99 -106 164 -59
117 -90 161 -192 270 -36 39 -85 95 -108 125 -68 88 -130 149 -200 195 -36 23
-92 66 -125 94 -84 71 -246 187 -271 195 -12 4 -61 48 -110 99 -106 111 -279
244 -393 301 -28 14 -65 39 -83 55 -92 80 -165 104 -188 62z m128 -116 c20
-20 65 -49 99 -65 34 -16 76 -42 95 -58 18 -16 68 -54 112 -86 76 -56 128
-105 230 -214 27 -28 56 -52 65 -52 25 0 120 -81 280 -239 80 -79 196 -181
256 -226 108 -80 205 -175 250 -245 12 -19 50 -89 85 -155 34 -66 85 -150 111
-186 27 -37 49 -71 49 -76 0 -15 30 -73 69 -132 76 -114 77 -115 52 -150 -14
-20 -50 -44 -99 -67 -99 -45 -133 -64 -154 -84 -21 -19 -235 -125 -323 -160
-91 -36 -188 -60 -243 -60 -46 0 -80 -10 -160 -46 -18 -8 -56 -19 -85 -24 -71
-12 -160 -42 -263 -90 -47 -22 -118 -49 -158 -59 -87 -24 -218 -31 -223 -14
-3 7 0 45 7 85 9 64 22 97 78 206 29 54 32 63 32 84 0 13 7 36 15 52 8 15 15
40 15 55 0 14 6 55 14 91 9 36 20 101 26 145 7 44 20 107 31 140 57 175 63
680 10 884 -11 40 -40 115 -65 167 -25 51 -59 134 -75 184 -39 116 -56 153
-103 217 -84 115 -119 213 -77 213 6 0 27 -16 47 -35z m4 -235 c33 -43 66
-124 103 -253 46 -167 84 -332 94 -412 6 -49 16 -128 22 -175 30 -230 29 -332
-6 -560 -9 -58 -20 -135 -25 -172 -5 -38 -11 -72 -14 -77 -4 -5 -13 -49 -22
-98 -22 -130 -44 -192 -107 -306 -18 -31 -27 -64 -28 -95 -1 -26 -5 -60 -9
-77 -7 -28 -8 -26 -9 15 -1 25 -8 76 -16 115 -20 94 -19 112 10 169 30 59 33
124 8 187 -14 36 -17 84 -19 274 -1 127 -7 327 -15 445 -7 118 -12 294 -10
390 6 362 4 488 -6 580 -6 52 -8 99 -6 103 6 10 5 10 55 -53z m1108 -2694
c223 -2 560 1 749 6 189 5 346 6 349 3 8 -8 -17 -101 -43 -160 -22 -51 -28
-75 -60 -230 -40 -194 -155 -342 -343 -441 -6 -3 -30 1 -52 10 -62 25 -153 19
-235 -14 -11 -5 -45 -16 -75 -26 -30 -9 -87 -32 -126 -50 -39 -19 -76 -34 -81
-34 -6 0 -32 -12 -57 -26 -40 -22 -56 -26 -110 -22 -59 3 -83 12 -233 85 -17
8 -45 35 -63 59 -26 36 -50 54 -133 94 -118 57 -193 70 -292 50 -33 -7 -78
-15 -101 -19 -46 -8 -118 -47 -168 -92 -19 -16 -53 -36 -77 -44 -24 -8 -53
-19 -64 -25 -11 -5 -69 -21 -128 -35 -98 -24 -114 -26 -175 -16 -95 16 -166
40 -252 83 -41 21 -84 38 -96 38 -11 0 -55 24 -98 52 -43 29 -97 66 -120 81
-58 39 -127 57 -219 57 -181 0 -410 -77 -553 -186 -39 -30 -76 -54 -83 -54
-12 0 -87 56 -121 90 -8 8 -37 33 -64 54 -65 52 -86 74 -148 154 -106 135
-146 215 -163 332 -4 25 -14 70 -22 100 -31 112 -43 100 99 100 69 0 150 5
179 10 38 8 92 7 179 0 88 -8 150 -8 208 -1 66 8 95 8 145 -4 89 -21 390 -20
477 1 77 19 226 21 290 4 76 -21 607 -25 817 -7 98 9 212 16 253 16 41 0 127
4 190 9 63 6 138 8 165 5 28 -2 232 -5 455 -7z"/>              <path d="M3245 3141 c-3 -5 ..."/>
              <path d="M710 500 c0 -5 ..."/>
              <path d="M685 480 c-3 -5 ..."/>
            </g>
          </svg>
        </div>
        <img
          src={text}
          alt="text_logo"
          className="lakeview-text-under"
        />
      </div>
    </div>
  );
};

export default LakeviewLoader;
